import { createSvgIcon } from 'shared/icons/IconUtils';

export const InstantIcon = createSvgIcon(
  'Instant',
  <path
    fill="currentColor"
    d="M15.458 3L6 12.508h5.861l-4.989 7.825L18 10.008h-6L15.458 3z"
  />,
);
